export function normalizeName(s) {
  return String(s || "")
    .trim()
    .replace(/\s+/g, " ");
}

export function slugifyId(name) {
  const base = normalizeName(name)
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$|_/g, "");
  const ts = Date.now().toString(36);
  return `${base}-${ts}`;
}
